import { j as e } from "../../../../jsx-runtime-B6kdoens.js";
import { forwardRef as t } from "react";
import { I as c } from "../../../../IconBase-CxZyIWw2.js";
const r = t((o, i) => /* @__PURE__ */ e.jsx(
  c,
  {
    ref: i,
    ...o,
    image: (l) => /* @__PURE__ */ e.jsx(
      "svg",
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 32,
        height: 32,
        fill: "none",
        viewBox: "0 0 32 32",
        ...l,
        children: /* @__PURE__ */ e.jsx(
          "path",
          {
            fill: "currentColor",
            fillRule: "evenodd",
            d: "M17.44 13.213C23.575 6.91 21.003 0 15.604 0c-1.178 0-2.356.44-3.255 1.318A4.44 4.44 0 0 0 11 4.5c0 2.035 1.395 3.37 2.796 4.71 1.143 1.093 2.289 2.19 2.685 3.673.111.419.657.641.96.33m-2.88 5.574C8.425 25.09 10.998 32 16.397 32c1.178 0 2.356-.44 3.255-1.318A4.44 4.44 0 0 0 21 27.5c0-2.035-1.395-3.37-2.796-4.71-1.143-1.093-2.289-2.19-2.685-3.673-.111-.419-.657-.641-.96-.33M32 15.603c0 5.4-6.91 7.972-13.213 1.838-.311-.303-.089-.848.33-.96 1.483-.396 2.58-1.542 3.673-2.685C24.13 12.396 25.465 11 27.5 11c1.152 0 2.303.45 3.182 1.348A4.64 4.64 0 0 1 32 15.603M13.213 14.56C6.91 8.425 0 10.998 0 16.397c0 1.178.44 2.356 1.318 3.255A4.44 4.44 0 0 0 4.5 21c2.035 0 3.37-1.395 4.71-2.796 1.093-1.143 2.19-2.289 3.673-2.685.419-.111.641-.657.33-.96",
            clipRule: "evenodd"
          }
        )
      }
    )
  }
));
r.displayName = "OftenOilyIcon";
export {
  r as OftenOilyIcon,
  r as default
};
//# sourceMappingURL=index.js.map
